import icBudget1 from 'Assets/img/sidebar/ic_noty_budget.png';
import icBudget2 from 'Assets/img/sidebar/ic_noty_budget@2x.png';
import icBudget3 from 'Assets/img/sidebar/ic_noty_budget@3x.png';
import icChat11 from 'Assets/img/sidebar/ic_noty_chat_1.png';
import icChat12 from 'Assets/img/sidebar/ic_noty_chat_1@2x.png';
import icChat13 from 'Assets/img/sidebar/ic_noty_chat_1@3x.png';
import icChat21 from 'Assets/img/sidebar/ic_noty_chat_2.png';
import icChat22 from 'Assets/img/sidebar/ic_noty_chat_2@2x.png';
import icChat23 from 'Assets/img/sidebar/ic_noty_chat_2@3x.png';
import icCommon1 from 'Assets/img/sidebar/ic_noty_common.png';
import icCommon2 from 'Assets/img/sidebar/ic_noty_common@2x.png';
import icCommon3 from 'Assets/img/sidebar/ic_noty_common@3x.png';
import icLedger1 from 'Assets/img/sidebar/ic_noty_ledger.png';
import icLedger2 from 'Assets/img/sidebar/ic_noty_ledger@2x.png';
import icLedger3 from 'Assets/img/sidebar/ic_noty_ledger@3x.png';
import icOrder1 from 'Assets/img/sidebar/ic_noty_order.png';
import icOrder2 from 'Assets/img/sidebar/ic_noty_order@2x.png';
import icOrder3 from 'Assets/img/sidebar/ic_noty_order@3x.png';
import icReport1 from 'Assets/img/sidebar/ic_noty_report.png';
import icReport2 from 'Assets/img/sidebar/ic_noty_report@2x.png';
import icReport3 from 'Assets/img/sidebar/ic_noty_report@3x.png';
import icNote1 from 'Assets/img/sidebar/ic_noty_note.png';
import icNote2 from 'Assets/img/sidebar/ic_noty_note@2x.png';
import icNote3 from 'Assets/img/sidebar/ic_noty_note@3x.png';
import { setDefaultField } from 'Actions/ConfigActions';
import { getImageSet } from 'Util/DataUtils';
import {
  LEDGER_ITEM_ADDED,
  SALES_NOTE_ITEM_ADDED,
  MATERIAL_BUDGET_REQUEST,
  FIELD_MOM,
  BUDGET,
  CHAT1,
  CHAT2,
  CHAT3,
  COMMON,
  LEDGER,
  ORDER,
  REPORT,
  NOTE,
  FIELD_WORK_LOG,
  FIELD_WORK_LOG_COMMENT,
  FIELD_COMMENT,
  FIELD_JOINED_STAFF,
  O_S_CUSTOMER_JOIN,
  INQUIRY_SETTING_MATERIAL,
  FIELD_INVITATION_ACCEPT,
} from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const icBudget = getImageSet([icBudget1, icBudget2, icBudget3]);
const icChat1 = getImageSet([icChat11, icChat12, icChat13]);
const icChat2 = getImageSet([icChat21, icChat22, icChat23]);
const icCommon = getImageSet([icCommon1, icCommon2, icCommon3]);
const icLedger = getImageSet([icLedger1, icLedger2, icLedger3]);
const icOrder = getImageSet([icOrder1, icOrder2, icOrder3]);
const icReport = getImageSet([icReport1, icReport2, icReport3]);
const icNote = getImageSet([icNote1, icNote2, icNote3]);

const getCategoryCommonData = type => {
  if (type === BUDGET) {
    return {
      icon: icBudget,
      labelId: 'dashboard.field.account.book',
    };
  } else if (type === CHAT1) {
    return {
      icon: icChat1,
      labelId: 'field.comment.title.comment',
    };
  } else if (type === CHAT2) {
    return {
      icon: icChat2,
      labelId: 'field.comment.title.clientComment',
    };
  } else if (type === CHAT3) {
    return {
      icon: icChat1,
      labelId: 'field.comment.title.surComment',
    };
  } else if (type === LEDGER) {
    return {
      icon: icLedger,
      labelId: 'dashboard.field.account.book',
    };
  } else if (type === ORDER) {
    return {
      icon: icOrder,
      labelId: 'sidebar.order',
    };
  } else if (type === REPORT) {
    return {
      icon: icReport,
      labelId: 'dashboard.field.report',
    };
  } else if (type === NOTE) {
    return {
      icon: icNote,
      labelId: 'field.salesNote',
    };
  } else {
    return {
      icon: icCommon,
      labelId: 'header.notification.title',
    };
  }
};

const useNotificationRoute = () => {
  const { allFieldList } = useSelector(state => state.config);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const changeDefaultField = useCallback(
    fieldId => {
      const field = allFieldList.find(field => field._id === fieldId);
      if (field) {
        dispatch(setDefaultField(field));
      }
    },
    [allFieldList, dispatch]
  );

  const getCategoryData = useCallback(
    ({ toType, toModel, object: originObject, to }) => {
      const object = originObject ? JSON.parse(originObject) : {};
      if (toType === LEDGER_ITEM_ADDED) {
        // 가계부 화면
        // default 현장 변경, 항목 상세 이동
        return {
          ...getCategoryCommonData(LEDGER),
          onClick: () => {
            changeDefaultField(object.fieldId);
            navigate('/admin/field/account-book', { state: { itemId: object.itemId } });
          },
        };
      } else if (toType === SALES_NOTE_ITEM_ADDED) {
        // 영업노트(간편) 화면
        // default 현장 변경, 항목 상세 이동
        return {
          ...getCategoryCommonData(NOTE),
          onClick: () => {
            changeDefaultField(object.fieldId);
            navigate('/admin/field/sales-note', { state: { itemId: object.salesNoteItemId } });
          },
        };
      } else if ([MATERIAL_BUDGET_REQUEST].indexOf(toType) >= 0) {
        // 현장예산 화면
        // default 현장 변경
        return {
          ...getCategoryCommonData(BUDGET),
          onClick: () => {
            changeDefaultField(to);
            navigate('/admin/field/budget');
          },
        };
      } else if (toType === FIELD_MOM) {
        // 회의록 화면
        // default 현장 변경, 회의록 상세 이동
        return {
          ...getCategoryCommonData(COMMON),
          onClick: () => {
            changeDefaultField(to);
            navigate(`/admin/field/minutes-of-meetings/${object._momId}`);
          },
        };
      } else if ([FIELD_WORK_LOG, FIELD_WORK_LOG_COMMENT].indexOf(toType) >= 0) {
        // 현장 보고 화면
        // default 현장 변경, 현장 보고 상세 이동
        const workLogId = object._workLogId;
        return {
          ...getCategoryCommonData(REPORT),
          onClick: () => {
            changeDefaultField(object._fieldId);
            navigate('/admin/field/work-logs', { state: { workLogId } });
          },
        };
      } else if (toType === FIELD_COMMENT) {
        // 대화방 화면
        // CHAT2 일때 고객 대화방으로 이동
        // default 현장 변경
        return {
          ...getCategoryCommonData(object.type === 'clientComment' ? CHAT2 : object.type === 'surComment' ? CHAT3 : CHAT1),
          onClick: () => {
            changeDefaultField(to);
            navigate('/admin/field/comment', { state: { type: object.type } });
          },
        };
      } else if (toType === FIELD_INVITATION_ACCEPT) {
        // 대화방 화면
        // 고객 대화방으로 이동
        // default 현장 변경
        return {
          ...getCategoryCommonData(COMMON),
          onClick: () => {
            changeDefaultField(to);
            navigate('/admin/field/comment', { state: { type: 'clientComment' } });
          },
        };
      } else if (toModel === 'OrderSupport') {
        return {
          ...getCategoryCommonData(NOTE),
          onClick: () => {
            changeDefaultField(object.fieldId);
            navigate('/admin/field/sales-note');
          },
        };
      } else if (['OrderMaterial', 'ORDER_MATERIAL'].includes(toModel)) {
        return {
          ...getCategoryCommonData(ORDER),
          onClick: () => {
            navigate(`/admin/transaction/order/detail/${to}`);
          },
        };
      } else if ([FIELD_JOINED_STAFF, O_S_CUSTOMER_JOIN, INQUIRY_SETTING_MATERIAL].indexOf(toType) >= 0) {
        // 현장 홈화면
        return {
          ...getCategoryCommonData(COMMON),
          onClick: () => {
            changeDefaultField(to);
            navigate('/admin/dashboard/field');
          },
        };
      } else {
        // 홈 전체현장
        // [MATERIAL_BUDGET_PLAN, MATERIAL_FIELD_SCHEDULE, INQUIRY_REQUEST_DESIGN, INQUIRY_SETTING_FAVORITE]
        return {
          ...getCategoryCommonData(COMMON),
          onClick: () => {
            navigate('/admin/dashboard');
          },
        };
      }
    },
    [changeDefaultField, navigate]
  );

  return { getCategoryData };
};

export default useNotificationRoute;
